import { confirm } from '../../../lib/bootbox'

export const confirmChangeOfStepStorage = (): Promise<boolean> => {
  return confirm(
    'Do you really want to change step storage in live bot? It can break conditions or analytics if not used wisely.'
  )
}
